// Switching Chatwoot inboxes through SDK.reset() navigates its iframe and
// leaves an extra step in the browser Back stack. A document replacement
// starts the new inbox without adding an application history entry.
export const reloadForChatwootInbox = (previousWebsiteToken?: string) => {
  // Chatwoot shares its conversation cookie across inboxes. Clear the old
  // session before booting the new document, as SDK.reset() normally would.
  document.cookie = "cw_conversation=; Max-Age=0; Path=/; SameSite=Lax";
  if (previousWebsiteToken) {
    document.cookie = `cw_user_${previousWebsiteToken}=; Max-Age=0; Path=/; SameSite=Lax`;
  }
  window.location.replace(window.location.href);
};
